'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense, use } from 'react';
import ActionWorldCard from '@/components/ActionWorldCard';
import { useAppLoaderContext } from '@/context/AppLoaderContext';
import { useOwnerProfileContext } from '@/context/OwnerProfileContext';
import { useRoomPolicy } from '@/hooks/useRoomPolicy';
import { useRouter } from '@/i18n/navigation';
import type { Room } from '@/services/cms';
import { useTranslations } from 'next-intl';
type UserCoOwnedWorldsProps = {
  stopSetAsFeatured: boolean;
};
function UserCoOwnedWorldsContent(t0) {
  const $ = _c(21);
  const {
    stopSetAsFeatured
  } = t0;
  const t = useTranslations();
  const {
    setIsAppLoading
  } = useAppLoaderContext();
  const {
    coOwnedRoomsPromise
  } = useOwnerProfileContext();
  const roomPolicy = useRoomPolicy();
  const router = useRouter();
  const coOwnedRooms = use(coOwnedRoomsPromise);
  if (!coOwnedRooms || coOwnedRooms.length < 1) {
    return null;
  }
  let t1;
  if ($[0] !== router || $[1] !== setIsAppLoading) {
    t1 = function handleAfterMutatingWorld() {
      router.refresh();
      setIsAppLoading(false);
    };
    $[0] = router;
    $[1] = setIsAppLoading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleAfterMutatingWorld = t1;
  let t2;
  if ($[3] !== t) {
    t2 = t("profile-page.co-owned-section-title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <h2 className="subheader-2 md:header-5 text-vive-primary-20 relative mb-4 font-bold md:mb-6">{t2}</h2>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== coOwnedRooms || $[8] !== handleAfterMutatingWorld || $[9] !== roomPolicy || $[10] !== stopSetAsFeatured) {
    let t5;
    if ($[12] !== handleAfterMutatingWorld || $[13] !== roomPolicy || $[14] !== stopSetAsFeatured) {
      t5 = room => <div key={`co-owned-rooms-${room.id}`}><ActionWorldCard className="max-w-[306px] min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]" info={room} customDesc={Object.values(roomPolicy).find(policy => policy.value === room.policy)?.title || room.policy} showMoreAction={true} onAfterMutatingWorld={handleAfterMutatingWorld} isCoOwnedRoom={true} hidePremiumBadge={false} stopSetAsFeatured={stopSetAsFeatured} /></div>;
      $[12] = handleAfterMutatingWorld;
      $[13] = roomPolicy;
      $[14] = stopSetAsFeatured;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    t4 = coOwnedRooms.map(t5);
    $[7] = coOwnedRooms;
    $[8] = handleAfterMutatingWorld;
    $[9] = roomPolicy;
    $[10] = stopSetAsFeatured;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[16] !== t4) {
    t5 = <div><div className="no-scrollbar flex w-full flex-col max-lg:overflow-scroll max-lg:scroll-smooth"><div className="flex gap-5 md:-mx-2 md:gap-2 lg:flex-wrap lg:gap-2">{t4}</div></div></div>;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t5) {
    t6 = <section className="flex flex-col">{t3}{t5}</section>;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}
function UserCoOwnedWorlds(t0) {
  const $ = _c(2);
  const {
    stopSetAsFeatured
  } = t0;
  let t1;
  if ($[0] !== stopSetAsFeatured) {
    t1 = <Suspense fallback={null}><UserCoOwnedWorldsContent stopSetAsFeatured={stopSetAsFeatured} /></Suspense>;
    $[0] = stopSetAsFeatured;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default UserCoOwnedWorlds;